import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import saApi from "../../superadminApi";
import { ShieldCheck, Lock, Mail, Eye, EyeOff, AlertCircle, Building2 } from "lucide-react";

const SuperadminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    saApi.get("/superadmin/me").then(() => navigate("/superadmin/dashboard", { replace: true })).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await saApi.post("/superadmin/auth/login", { email: email.trim(), password });
      navigate("/superadmin/dashboard", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Credenziali non valide");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0b1220] via-[#111a2e] to-[#1b2a4a] px-6" data-testid="superadmin-login">
      <div className="w-full max-w-[420px]">
        <div className="text-center mb-8">
          <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#ff7e00]/15 border border-[#ff7e00]/40 mb-4">
            <ShieldCheck size={28} className="text-[#ff7e00]" />
          </span>
          <h1 className="text-white text-[26px] font-black tracking-tight">Console Superadmin</h1>
          <p className="text-gray-400 text-[13px] mt-1">Gestione multi-azienda e abbonamenti</p>
        </div>

        <form onSubmit={submit} className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl">
          {error && (
            <div className="flex items-start gap-2 bg-red-500/10 border border-red-500/30 text-red-300 text-[13px] px-3 py-2 rounded-lg mb-4" data-testid="superadmin-login-error">
              <AlertCircle size={16} className="mt-0.5 shrink-0" /> <span>{error}</span>
            </div>
          )}
          <label className="block text-[12px] font-semibold text-gray-300 mb-1">Email</label>
          <div className="flex items-center bg-white/5 border border-white/15 rounded-lg mb-4 focus-within:border-[#ff7e00] transition-colors">
            <span className="px-3 text-gray-400"><Mail size={17} /></span>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" data-testid="superadmin-email"
              placeholder="superadmin@..." className="flex-1 bg-transparent py-2.5 pr-3 text-[14px] text-white outline-none placeholder:text-gray-500" />
          </div>
          <label className="block text-[12px] font-semibold text-gray-300 mb-1">Password</label>
          <div className="flex items-center bg-white/5 border border-white/15 rounded-lg mb-6 focus-within:border-[#ff7e00] transition-colors">
            <span className="px-3 text-gray-400"><Lock size={17} /></span>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type={showPwd ? "text" : "password"} data-testid="superadmin-password"
              placeholder="Password" className="flex-1 bg-transparent py-2.5 text-[14px] text-white outline-none placeholder:text-gray-500" />
            <button type="button" onClick={() => setShowPwd(!showPwd)} className="px-3 text-gray-400 hover:text-white">
              {showPwd ? <EyeOff size={17} /> : <Eye size={17} />}
            </button>
          </div>
          <button type="submit" disabled={submitting} data-testid="superadmin-login-submit"
            className="w-full bg-[#ff7e00] hover:bg-[#e86f00] disabled:opacity-60 text-white font-bold text-[14px] py-3 rounded-lg uppercase tracking-wide transition-colors flex items-center justify-center gap-2">
            <Building2 size={16} /> {submitting ? "Accesso..." : "Accedi alla console"}
          </button>
        </form>
        <p className="text-center text-[11px] text-gray-500 mt-5">Area riservata · JOBTIMEHR</p>
      </div>
    </div>
  );
};

export default SuperadminLogin;
